import { render, staticRenderFns } from "./NewsletterWidget.vue?vue&type=template&id=e4ecbfa2&"
import script from "./NewsletterWidget.vue?vue&type=script&lang=js&"
export * from "./NewsletterWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/DIA-stylebreaker-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4ecbfa2')) {
      api.createRecord('e4ecbfa2', component.options)
    } else {
      api.reload('e4ecbfa2', component.options)
    }
    module.hot.accept("./NewsletterWidget.vue?vue&type=template&id=e4ecbfa2&", function () {
      api.rerender('e4ecbfa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/footer/NewsletterWidget.vue"
export default component.exports